module.exports = __webpack_public_path__ + "static/ogimage-9817c43548534c73421f123ef922809a.jpg";